import { useSession } from '@/context/session/useSession';
import Card from '../../ui/Card';
import Flex from '../../ui/Flex';
import UserAvatar from './UserAvatar';

export default function AccountInfoCard() {
  const { session } = useSession();

  const name = session?.user.user_metadata.name;
  const email = session?.user.email;

  return (
    <Card>
      <Flex.Col gap="5">
        <div className="font-semibold">Your email</div>
        <Flex.Row gap="2.5" className="items-center">
          <UserAvatar />
          <Flex.Col gap="0.5">
            {name && <div className="font-semibold">{name}</div>}
            {email && <div>{email}</div>}
          </Flex.Col>
        </Flex.Row>
      </Flex.Col>
    </Card>
  );
}
